import Cap from "@cap.js/widget";
import { environment } from "@app/dashboard/environments/environment";
import { getCountryFromDomain } from "./getCountryFromDomain";

const CAP_SITE_KEYS: Record<string, string> = {
  EGY: environment.CAP_SITE_KEY_EGY,
  ARE: environment.CAP_SITE_KEY_ARE,
  SAU: environment.CAP_SITE_KEY_SAU,
  OMN: environment.CAP_SITE_KEY_OMN,
};

const CAP_SITE_KEY = CAP_SITE_KEYS[getCountryFromDomain()];
const CAP_API_ENDPOINT = `${environment.CAP_BASE_URL}/${CAP_SITE_KEY}/`;
const CAP_TOKEN_HEADER = "X-Cap-Token" as const;

/** Runs programmatic Cap solve (no visible widget). Returns a one-time token for `X-Cap-Token`. 
 * @returns {Promise<string>} Promise that resolves with the Cap token
*/
export const getCapToken = async (): Promise<string> => {
  const cap = new Cap({ apiEndpoint: CAP_API_ENDPOINT });
  const { success, token } = await cap.solve();
  if (!success || !token) {
    throw new Error("Cap verification failed");
  }
  return token;
};

export const getCapHeadersConfig = async () => ({
  headers: { [CAP_TOKEN_HEADER]: await getCapToken() },
});
